type BrightbackSession = {
  addressState: string;
  callback(url: string): void;
  email: string;
  id: number;
  name: string;
  frequency: string;
  productName: string;
  sku: string;
  subscriptionId: number;
  value: number;
};

export async function handleBrightbackSession({
  addressState,
  callback,
  email,
  id,
  name,
  frequency,
  productName,
  sku,
  subscriptionId,
  value,
}: BrightbackSession) {
  try {
    const response = await fetch("https://app.brightback.com/precancel", {
      method: "POST",
      body: JSON.stringify({
        app_id: process.env.NEXT_PUBLIC_BRIGHTBACK_APP_ID,
        email,
        full_name: name,
        subscription_id: subscriptionId,
        account: {
          internal_id: subscriptionId,
          // additional fields outlined here https://help.brightback.com/article/43-installing-brightback
          plan_term: frequency,
          value,
        },
        custom: {
          customer_id: id,
          product: {
            name: productName,
            variant: {
              sku,
            },
          },
          state: addressState,
        },
      }),
    });
    const { message, url, valid } = await response.json();
    if (valid && url) {
      callback(url);
    } else if (!valid && message) {
      console.error(message);
    }
  } catch (error) {
    console.error(error);
  }
}
